import React from 'react';

const Sidenavbar = () => {
  return (
    <>
      {/* =====================================Mobile navbar navigation start================================================================================================================ */}

      <div className="offcanvas offcanvas_scroll offcanvas-start d-block d-lg-none" data-bs-scroll="true" data-bs-backdrop="false" tabIndex={-1} id="offcanvasScrolling" aria-labelledby="offcanvasScrollingLabel">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasScrollingLabel">
            <a href="/">
              <img src="../logo/logo.png" className="img-fluid" alt="Logo" />
            </a>
          </h5>
          <button type="button" data-bs-dismiss="offcanvas" aria-label="Close">
            <i className="bx bx-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="mobile_navbar">
            <ul className="main_ul">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About Us</a></li>
              {/* products li */}
              <li>
                <a href="javascript:void(0);">
                  Products</a> <span data-bs-toggle="collapse" data-bs-target="#products-menu" className="bx bx-chevron-down" />
                          </li>
              <div className="collapse" id="products-menu">
                <div className="card card-body profile_card_body">
                  <ul className="profile_ul">
                    {/* products sub  li */}
                    <li>
                      <a href="/hdpe-granules">
                        HDPE Granules </a>  <span data-bs-toggle="collapse" data-bs-target="#prosub_menu" className="bx bxs-chevron-down" />
                    </li>
                    <div className="collapse" id="prosub_menu">
                      <div className="card card-body prodct_submenu_cardbody">
                        <ul className="product_submenu_ul">
                          <li><a href="/HDPE-Granules/PE-100-SSBK-Granules">PE 100 SSBK Granules</a></li>
                          <li><a href="/HDPE-Granules/PE-80-SBK-Granules">PE 80 SBK Granules</a></li>
                          <li><a href="/HDPE-Granules/PE-63-BK-Granules">PE 63 BK Granules</a></li>
                          <li><a href="/HDPE-Granules/BD-(Blow-Grade)-Granules">BD (Blow Grade) Granules</a></li>
                          <li><a href="/HDPE-Granules/Natural-Granules">Natural Granules</a></li>
                          <li><a href="/HDPE-Granules/Milky-Granules">Milky Granules</a></li>
                          <li><a href="/HDPE-Granules/SSBL-Blue-Drum-Granules">SSBL Blue Drum Granules</a></li>
                          <li><a href="/HDPE-Granules/Custom-Compounded-Granules">Custom Compounded Granules</a></li>
                        </ul>
                      </div>
                    </div>
                    {/*products sub li end */}
                    {/* products sub  li */}
                    <li>
                      <a href="/lldpe-granules">
                        LLDPE Granules</a>  <span data-bs-toggle="collapse" data-bs-target="#prosub_menu2" className="bx bxs-chevron-down" />
                    </li>
                    <div className="collapse" id="prosub_menu2">
                      <div className="card card-body prodct_submenu_cardbody">
                        <ul className="product_submenu_ul">
                          <li><a href="/LLDPE-Granules/Cable-Compounding-N1-N2-granules">Cable Compounding N1, N2 granules</a></li>
                        </ul>
                      </div>
                    </div>
                    {/*products sub li end */}
                    {/* products sub  li */}
                    <li>
                      <a href="/ppcp-granules">PPCP Granules</a>  <span data-bs-toggle="collapse" data-bs-target="#prosub_menu3" className="bx bxs-chevron-down" />
                    </li>
                    <div className="collapse" id="prosub_menu3">
                      <div className="card card-body prodct_submenu_cardbody">
                        <ul className="product_submenu_ul">
                          <li><a href="/PPCP-Granules/Black-PPCP-Granules"> Black PPCP Granule</a></li>
                          <li><a href="/PPCP-Granules/Natural-PPCP-Granules">Natural PPCP Granule</a></li>
                        </ul>
                      </div>
                    </div>
                    {/*products sub li end */}
                     
                    

                      <li><a href="/custom-compounding">Custom Compounding</a></li>
                      <li><a href="/hdpe-dana">HDPE Dana</a></li>
                        {/* products sub  li */}
                    <li>
                      <a href="/ldpe-granules">LDPE Granules</a>  <span data-bs-toggle="collapse" data-bs-target="#prosub_menu3s" className="bx bxs-chevron-down" />
                    </li>
                    <div className="collapse" id="prosub_menu3s">
                      <div className="card card-body prodct_submenu_cardbody">
                        <ul className="product_submenu_ul">
                           <li><a href="/ldpe-dana">LDPE Dana</a></li> 
                        </ul>
                      </div>
                    </div>
                    {/*products sub li end */}
                      <li><a href="/lldpe-dana">LLDPE Dana</a></li>
                      <li><a href="/pp-dana">PP Dana</a></li>
                      <li><a href="/pp-granules">PP Granules</a></li>
                      <li><a href="/ppcp-dana">PPCP Dana</a></li>
                  </ul>
                </div>
              </div>
              {/*products drop li end */}
              <li className="nav-item"><a className="nav-link" href="/epr-services">EPR / Waste Management Service</a></li>
              <li className="nav-item"><a className="nav-link" href="/sitemap">Sitemap </a></li>
              <li className="nav-item"><a className="nav-link" href="/contact-us">Contact Us</a></li>
            </ul>
          </div>
          {/* contact us div */}
          <div className="offcanvas_conatct_div">
            {/* div number */}
            <p>
              <a href="tel:+91-9810347240"><i className="bx bx-phone-outgoing" /> +91-9810347240</a>
              <a href="tel:+91-9310347240"><i className="bx bx-phone-outgoing" /> +91-9310347240</a>
              <a href="mailto:info@vanshikaplastic.com"> <i className="bx bx-mail-send" /> info@vanshikaplastic.com</a>
              <a href="mailto:sales@vanshikaplastic.com"> <i className="bx bx-mail-send" /> sales@vanshikaplastic.com</a>
            </p>
            <b> <i className="bx bx-map" /> Office & Unit-1:</b>
            <p>D-25 & 26 Sector-5, D.S.I.I.D.C Bawana Industrial Area, Delhi 110039 - (INDIA)</p>
            <b> <i className="bx bx-map" /> Unit-2:</b>
            <p>G1-228 RIICO Industrial Area Kahrani Bhiwadi Rajasthan 301019 - (INDIA)</p>
            {/* div number */}
          </div>
          {/* contact us div end */}
        </div>
      </div>
      {/* =====================================Mobile navbar navigation end================================================================================================================ */}
    </>
  );
};

export default Sidenavbar;
